import { Injectable, Scopes } from '@visiba/instantiation';
import { HttpService, VisibaApiPromise, VisibaOptions } from '@services/http.service';
import type { HttpCancelTokenSource } from '@visiba/http';
import type { HomeGuiComponentsApiModel, SearchApiModel } from './generated/models';
import type { LicenceHolderLanguageApiModel } from './models/LicenceHolderLanguageApiModel';

@Injectable({
	scope: Scopes.Singleton,
})
export class LicenceHolderApiService {
	private static readonly baseUri_OLD = (id: number): string => `Client/LicenceHolder/${id}`;
	private static readonly baseUri = 'client/v2';

	constructor(private readonly httpService: HttpService) {
		// Empty
	}

	public getSupportedLanguages(licenceHolder: number): VisibaApiPromise<LicenceHolderLanguageApiModel[]> {
		return this.httpService.get(`${LicenceHolderApiService.baseUri_OLD(licenceHolder)}/Languages`);
	}

	public getHomeGuiComponents(licenceHolder: number): VisibaApiPromise<HomeGuiComponentsApiModel> {
		return this.httpService.get(`${LicenceHolderApiService.baseUri}/${licenceHolder}/HomeGuiComponents`);
	}

	public getTranslationSet(
		licenceHolderId: number,
		translationsSet: string,
		languageCode: string,
	): VisibaApiPromise<Record<string, string>> {
		return this.httpService.get(
			`${LicenceHolderApiService.baseUri}/${licenceHolderId}/translationSets/${translationsSet}/${languageCode}`,
		);
	}

	public search(
		licenceHolder: number,
		text: string,
		cancelToken?: HttpCancelTokenSource,
		// TODO PAT-426: Missing Path, Name and Subtitle?!
	): VisibaApiPromise<(SearchApiModel & { Path: string; Name: string; Subtitle: string })[]> {
		const httpOptions = new VisibaOptions({
			cancelToken,
		});

		return this.httpService.get(`${LicenceHolderApiService.baseUri}/${licenceHolder}/receptions/search?query=${text}`, httpOptions);
	}
}
